import React, { LegacyRef, useEffect, useRef } from 'react';
import { useIntersectionObserver } from '@fiverr-private/hooks';
import { PortfolioWidget } from '@fiverr-private/portfolio';
import { SafeWrapper } from '@fiverr-private/seller_pages_toolbox';
import { PAGE_NAME, useMonitoring } from '../../../monitoring/index';
import { FreelancerPortfolioProps } from './types';

const FreelancerPortfolio: React.FC<FreelancerPortfolioProps> = ({ seller }) => {
    const { Providers, fireEvents } = useMonitoring();

    useEffect(() => {
        fireEvents({
            [Providers.BigQuery]: {
                type: 'business_seller_portfolio_component_exists',
            },
        });
    }, [seller.user.id]);

    const observableRef = useRef<HTMLElement>(null);
    const entry = useIntersectionObserver(observableRef, { threshold: 1 });
    const isVisible = Boolean(entry?.isIntersecting);

    useEffect(() => {
        if (isVisible) {
            fireEvents({
                [Providers.Mixpanel]: {
                    type: 'Seller portfolio - Viewed',
                },
            });
        }
    }, [isVisible, Providers.Mixpanel, fireEvents]);

    return (
        <div ref={observableRef as LegacyRef<HTMLDivElement>}>
            <PortfolioWidget
                username={seller.user.name}
                biEnrichment={{
                    page: {
                        name: PAGE_NAME,
                    },
                }}
                cardSize={{ md: 'md', lg: 'lg' }}
                thumbnailsPosition={{ md: 'right' }}
                thumbnailsAmount={{
                    sm: 4,
                    md: 6,
                    lg: 5,
                    xl: 6,
                }}
            />
        </div>
    );
};

const SafeFreelancerPortfolio = SafeWrapper(FreelancerPortfolio, 'FreelancerPortfolio');

export { SafeFreelancerPortfolio as FreelancerPortfolio };
